import { useSelector } from 'react-redux';

const useIsAuthenticated = () => {
  const { authenticated } = useSelector((state) => state.userInfo);
  return authenticated;
};

export default useIsAuthenticated;
